import { ReactNode } from "react";

interface DetailCardProps {
  title?: string;
  /** Optional element rendered at the right of the title bar. */
  action?: ReactNode;
  children: ReactNode;
  /** Body padding override (design uses "14px 20px" for the Resources card). */
  pad?: string;
}

// Titled white card, matched to the "Discover (A)" design (detail.jsx Card):
// border #EAECF0, radius 8, xs shadow; a 13px/20px title bar with a bottom
// divider (14px/600 title), then an 18px/20px body.
export const DetailCard = ({ title, action, children, pad = "18px 20px" }: DetailCardProps) => {
  return (
    <div
      style={{
        border: "1px solid #EAECF0",
        borderRadius: 8,
        background: "#fff",
        boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
      }}
    >
      {title && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "13px 20px",
            borderBottom: "1px solid #EAECF0",
          }}
        >
          <span style={{ fontSize: 14, fontWeight: 500, color: "#101828" }}>{title}</span>
          {action}
        </div>
      )}
      <div style={{ padding: pad }}>{children}</div>
    </div>
  );
};
